export const isFeatureAvailable = (networkConfiguration = {}, feature) =>
  !!(
    networkConfiguration?.[feature]?.published ||
    networkConfiguration?.[feature]?.accessible
  );

export const areFeaturesEnabled = (networkConfiguration = {}, ...features) =>
  features.every((feature) => isFeatureEnabled(networkConfiguration, feature));

export const isFeatureEnabled = (networkConfiguration = {}, feature) =>
  !!networkConfiguration?.[feature]?.enabled;

export const isFeatureConfigurable = (networkConfiguration = {}, feature) =>
  !!networkConfiguration?.[feature]?.configurable;

export const isInternalMessagingAvailable = (currentNetwork) =>
  isFeatureAvailable(currentNetwork?.network_configuration, 'messaging');

export const isInternalMessagingConfigurable = (currentNetwork) =>
  isFeatureConfigurable(currentNetwork?.network_configuration, 'messaging');

export const isUserInvitationsAvailable = (currentNetwork) =>
  isFeatureAvailable(currentNetwork?.network_configuration, 'user_invitations');
